import { Tree } from 'element-ui';

/**
 * Element-UI的帮助器
 * 弥补Element-UI的不足
 */
export class ElementUIHelper {
  public static expendNode(tree: Tree, nodeKey: string) {
    const nodes = tree.store._getAllNodes();
    for (let i = 0; i < nodes.length; i++) {
      if (nodes[i].data.id === nodeKey) {
        nodes[i].expanded = true;
        break;
      }
    }
  }
}
